import { render, staticRenderFns } from "./error-warning-frame-dialog.vue?vue&type=template&id=776a1624"
import script from "./error-warning-frame-dialog.vue?vue&type=script&lang=js"
export * from "./error-warning-frame-dialog.vue?vue&type=script&lang=js"
import style0 from "./error-warning-frame-dialog.vue?vue&type=style&index=0&id=776a1624&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports